module.exports = __webpack_public_path__ + "img/iphone-11.6bf49112.png";